import { OverlayModule as CdkOverlayModule } from '@angular/cdk/overlay';
import { PortalModule as CdkPortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionModule } from './accordion/accordion.module';
import { AttachmentsModule } from './attachments/attachments.module';
import { DatePickerModule } from './date-picker/date-picker.module';
import { FilterGroupModule } from './filter-group/filter-group.module';
import { FormsModule } from './forms/forms.module';
import { IconButtonModule } from './icon-buttons/icon-button.module';
import { KeyboardModule } from './keyboard/keyboard.module';
import { ModalDialogModule } from './modal-dialog/modal-dialog.module';
import { PaginationModule } from './pagination/pagination.module';
import { PipeModule } from './pipes/pipe.module';
import { PortalApiModule } from './portal/portal.module';
import { TableModule } from './tables/table.module';
import { TabsModule } from './tabs/tabs.module';
import { TreeModule } from './tree/tree.module';
import { JobService } from './utils/job.service';
import { UtilModule } from './utils/util.module';

/**
 * Alle Module, die {@link CommonUiCommonModule} exportiert.
 */
const MODULES = [
    // Angular Core
    CommonModule,

    // Nicht notwendig, da unser FormsModule das bereits exportiert
    // NgFormsModule,
    // ReactiveFormsModule,

    // CDK
    CdkOverlayModule,
    CdkPortalModule,

    // SPP
    AccordionModule,
    AttachmentsModule,
    DatePickerModule,
    FilterGroupModule,
    FormsModule,
    PaginationModule,
    PipeModule,
    PortalApiModule,
    TableModule,
    TabsModule,
    TreeModule,
    UtilModule,
    IconButtonModule,
    ModalDialogModule,
    KeyboardModule,
];

/**
 * Das Common-Ui-Common-Module deklariert selbst keine Komponenten. Es importiert und exportiert
 * ALLE Komponenten, die in SPP Common Ui deklariert sind. Es fast also alle Untermodule in einem
 * Modul zusammen. Die Unter-Module können theoretisch auch alleine verwendet werden.
 */
@NgModule({
    imports: MODULES,
    exports: MODULES,
    providers: [JobService]
})
export class CommonUiCommonModule {
}
